import styled from "styled-components";
import { theme } from "../../../theme";

const CardTitleTypo = styled.span`
  ${theme.typo.heading.b18};
  color: ${theme.colors.gray2};
`;

const DescriptionTypo = styled.span`
  ${theme.typo.body.r14};
  color: ${theme.colors.gray4};
`;

/**
 * 예약불가시간
 */
const TimesTitleTypo = styled.span`
  ${theme.typo.heading.b16};
  color: ${theme.colors.gray2};
`;

/**
 * n타임
 */
const TimesCountTypo = styled.span`
  ${theme.typo.heading.b14};
  color: ${theme.colors.red3};
`;

export { CardTitleTypo, DescriptionTypo, TimesTitleTypo, TimesCountTypo };
